import * as Yup from 'yup';
import { RETAINER_ATTRIBUTES } from './constants';
import { SCAN_SUBMISSION_METHODS, SCANNERS } from '../IDB/constants';
import { caseNumberSchema, createValidationSchema, patientNameSchema } from '../validation';

const retainerSchema = {
  [RETAINER_ATTRIBUTES.FIRST_NAME]: patientNameSchema,
  [RETAINER_ATTRIBUTES.LAST_NAME]: patientNameSchema,
  [RETAINER_ATTRIBUTES.CASE_NUMBER_TEXT]: caseNumberSchema,
  [RETAINER_ATTRIBUTES.ARCH_TYPE]: Yup.number().required('Required'),
  [RETAINER_ATTRIBUTES.RETAINER_CUT_TYPE]: Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .required('Required'),
  [RETAINER_ATTRIBUTES.SCAN_SUBMISSION_METHOD]: Yup.number().required('Required'),
  [RETAINER_ATTRIBUTES.CUSTOM_SCANNER_NAME]: Yup.string().when(RETAINER_ATTRIBUTES.SCANNER, {
    is: val => val === SCANNERS.OTHER,
    then: Yup.string().required('Required')
  }),
  [RETAINER_ATTRIBUTES.STL_FILES]: Yup.array().when(RETAINER_ATTRIBUTES.SCAN_SUBMISSION_METHOD, {
    is: val => Number(val) === SCAN_SUBMISSION_METHODS.UPLOAD,
    then: Yup.array()
      .of(
        Yup.object().shape({
          file_path: Yup.string().required('Required'),
          name: Yup.string().required('Required')
        })
      )
      .required('Required')
      .min(1),
    otherwise: validationSchema => validationSchema.nullable()
  }),
  [RETAINER_ATTRIBUTES.INTRAORAL_PHOTOS]: Yup.array()
    .of(
      Yup.object().shape({
        file_path: Yup.string().required('Required'),
        name: Yup.string().required('Required')
      })
    )
    .required('Required')
    .min(1),
  [RETAINER_ATTRIBUTES.SHIPPING_LOCATION]: Yup.number().required('Required'),
  [RETAINER_ATTRIBUTES.SHIPPING_METHOD]: Yup.string().required('Required'),
  [RETAINER_ATTRIBUTES.NOTES]: Yup.string().nullable()
};

export const retainerBaseSchema = retainerSchema;

export const createRetainerValidationSchema = (
  attributes = [],
  overrideOptions = {},
  newControls = []
) => createValidationSchema(retainerSchema, attributes, overrideOptions, newControls);
